import { getLoanData } from '@Redux/ApplyLoan/action';
import { getDocumentStatus } from '@Redux/Manual_Kyc_Details/action';
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import AgreementImage from "../../../Images/Agreement.png";
import DisbursalImage from "../../../Images/Disbursal.webp";
import { default as PendingImage, default as kycImage } from "../../../Images/PendingIcon.png";
import tick from "../../../Images/superTick.png";

function SuperAppToggle(props) {
    const { number } = props;
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth > 440);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const dynamicLineWidth = isLargeScreen ? "100px" : "48px";

    return (
        <div>
            <div className='superProgress'>
                {/* Step 1: Basic Details */}
                <div style={{ display: "flex", flexDirection: "row", alignItems: 'center' }}>
                    <div className='superPart'>
                        <img src={number === 1 ? PendingImage : number > 1 ? tick : tick} height={28} width={28} alt="Basic Details step" />
                        <div>
                            <p className='superToggleImageText'>Basic Details</p>
                        </div>
                    </div>
                    <div
                        style={number >= 2
                            ? { border: '0.4px solid #16C96F', width: dynamicLineWidth }
                            : { border: '0.4px solid #E8E9EC', width: dynamicLineWidth }}
                        className='superLineApp'
                    />
                </div>

                {/* Step 2: KYC */}
                <div style={{ display: "flex", flexDirection: "row", alignItems: 'center' }}>
                    <div className='superPart'>
                        <img src={number === 2 ? PendingImage : number > 2 ? tick : kycImage} height={28} width={28} alt="KYC step" />
                        <div>
                            <p className='superToggleImageKyc mrl-5'>KYC</p>
                        </div>
                    </div>
                    <div
                        style={number >= 3
                            ? { border: '0.4px solid #16C96F', width: dynamicLineWidth }
                            : { border: '0.4px solid #E8E9EC', width: dynamicLineWidth }}
                        className='superLineApp'
                    />
                </div>

                {/* Step 3: Agreement */}
                <div style={{ display: "flex", flexDirection: "row", alignItems: 'center' }}>
                    <div className='superPart'>
                        <img src={number === 3 ? PendingImage : number > 3 ? tick : AgreementImage} height={28} width={28} alt="Agreement step" />
                        <div className="">
                            <p className='superToggleImagePart'>Agreement</p>
                        </div>
                    </div>
                    <div
                        style={number >= 4
                            ? { border: '0.4px solid #16C96F', width: dynamicLineWidth }
                            : { border: '0.4px solid #E8E9EC', width: dynamicLineWidth }}
                        className='superLineApp'
                    />
                </div>

                {/* Step 4: Disbursal */}
                <div style={{ display: "flex", flexDirection: "row", alignItems: 'center' }}>
                    <div className='superPart'>
                        <img src={number === 4 ? PendingImage : number > 4 ? tick : DisbursalImage} height={28} width={28} alt="Disbursal step" />
                        <div className="">
                            <p className='superToggleImagePart'>Disbursal</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

export default connect(mapStateToProps, {
    getLoanData,
    getDocumentStatus
})(SuperAppToggle);
